export { ActivitiesPage, type ActivitiesPageProps } from "./ActivitiesPage"
